export const EMAIL_REGEX = new RegExp(/^[a-zA-Z0-9][\w.'+-]{0,63}@[a-zA-Z0-9-]{1,63}(\.[a-zA-Z0-9-]{1,63})*\.[a-zA-Z]{2,10}(\.[a-zA-Z]{2})?$/);
export const EMAIL_REGEX_SPECIAL = new RegExp(/^([\w+'-]{1,64}(?:\.[\w+'-]{1,64})*)@((?:[\w+-]+\.)*\w[\w+-]{0,66})\.([a-z]{2,10}(?:\.[a-z]{2})?)$/i);
